import React from 'react';
import adds from '../../../../assets/images/blog_page_adds_sidebar.png'
import "./sidebarAds.scss"
const SidebarAds = () => {
    return (
        <>
            <div class="first_adds">
                <img src={adds} alt="" />
            </div>
        </>
    );
};

export default SidebarAds;